import React from "react";
import { useTwilioAccount } from "@web-src/modules/client-support/pages/ClientSupportPage/providers/TwilioAccountProvider/useTwilioAccount";
import { TwilioConnectionForm } from "./components/TwilioConnectionForm";
import { TwilioAccountHeaderCard } from "./components/TwilioAccountHeaderCard";
import { AssociatedPhoneSection } from "./components/AssociatedPhoneSection";
import { TwilioHowItWorksSection } from "./components/TwilioHowItWorksSection";

export const TwilioAccountScreen: React.FC = () => {
  const { isConnected } = useTwilioAccount();

  return (
    <div className="flex h-full flex-col gap-6 overflow-y-auto bg-grey-100 p-8 max-lg:gap-4 max-lg:p-4">
      {isConnected ? (
        <>
          <TwilioAccountHeaderCard />
          <AssociatedPhoneSection />
          <TwilioHowItWorksSection />
        </>
      ) : (
        <TwilioConnectionForm />
      )}
    </div>
  );
};
